<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Data</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/Kalendar">Event Kalender</a></li>
                                <li class="breadcrumb-item active">Event Kalender</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Event Kalender</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label>Nama Agenda</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="agenda"
                                                    name="agenda" placeholder="Nama Agenda" v-model="agenda" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Nama Agenda (English)</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="agenda_eng"
                                                    name="agenda_eng" placeholder="Nama Agenda (English)"
                                                    v-model="agenda_eng" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Pelaksana</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="pengelola"
                                                    name="pengelola" placeholder="Pelaksana" v-model="pengelola"
                                                    disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Topik </label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="topik"
                                                    name="topik" placeholder="Topik" v-model="topik" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Topik (English)</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="topik_eng"
                                                    name="topik_eng" placeholder="Topik (English)" v-model="topik_eng"
                                                    disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Lokasi </label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="lokasi"
                                                    name="lokasi" placeholder="Lokasi" v-model="lokasi" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Tanggal Mulai </label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="date" class="form-control form-control-sm" id="mulai"
                                                    name="mulai" placeholder="Tanggal Mulai" v-model="mulai" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Jam Mulai</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="time" class="form-control form-control-sm" id="waktumulai"
                                                    name="waktumulai" placeholder="Jam Mulai" v-model="waktumulai"
                                                    disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Tanggal Selesai</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="date" class="form-control form-control-sm" id="selesai"
                                                    name="selesai" placeholder="Tanggal Selesai" v-model="selesai"
                                                    disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Jam Selesai</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="time" class="form-control form-control-sm"
                                                    id="waktuselesai" name="waktuselesai" placeholder="Jam Selesai"
                                                    v-model="waktuselesai" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Warna Kalender</label>
                                            <input type="color" class="form-control form-control-sm" id="warna"
                                                name="warna" placeholder="Warna Kalender" v-model="warna"
                                                style="width: 40px !important;" disabled>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="col-sm-12">
                                            <label>Penerima Undangan</label>
                                            <v-select multiple :options="hastag" :reduce="(label) => label.code"
                                                label="label" @option:selected="onhastagChangeSelect($event)"
                                                @option:deselected="onhastagChangeDeselect($event)"
                                                v-model="arraynamahastag" style="background-color: #ffffff;"
                                                disabled></v-select>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="col-sm-12">
                                            <label>Deskripsi Acara</label>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <quill-editor v-model:value="permasalahan" style="height: 25vh;"
                                                        disabled></quill-editor>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="col-sm-12">
                                            <label>Deskripsi Acara (English)</label>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <quill-editor v-model:value="permasalahan_eng" style="height: 25vh;"
                                                        disabled></quill-editor>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            &nbsp;
                                        </div>
                                        <div class="col-sm-12" v-if="filenya_dokumen != ''">
                                            <label>Lampiran File</label><br></br>
                                            <a :href="folder_dokumen + filenya_dokumen" target="_blank">
                                                Lihat Lampiran File
                                            </a>
                                        </div>
                                        <div class="col-sm-12">
                                            &nbsp;
                                        </div>
                                        <div class="col-sm-12" v-if="filenya_name != ''">
                                            <label>Lampiran Foto</label><br></br>
                                            <img class="w-50 h-50" v-if="filenya_name != ''"
                                                :src="folder_foto + filenya_name" alt="user image">
                                        </div>
                                        <div class="col-sm-12">
                                            &nbsp;
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Kembali.."><i class="fas fa-window-close"></i> Kembali</button>
                                </div>
                                <div class="col-sm-12">
                                    &nbsp;
                                </div>
                                <div class="col-sm-12">
                                    &nbsp;
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";
import { quillEditor } from 'vue3-quill';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            isistem: JSON.parse(localStorage.getItem("isistem")),
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            levelinstansi: JSON.parse(localStorage.getItem("inssistem")),
            roleuser: JSON.parse(localStorage.getItem("rlsistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            agenda: '',
            agenda_eng: '',
            pengelola: '',
            topik: '',
            topik_eng: '',
            lokasi: '',
            mulai: '',
            selesai: '',
            waktumulai: '',
            waktuselesai: '',
            datapesan: '',
            permasalahan: '',
            permasalahan_eng: '',
            warna: '',
            filenya_dokumen: '',
            filenya_name: '',
            datahastag: [],
            hastag: [],
            defaultSelectedhastag: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedhastag: '',
            paramselectedhastag: [],
            arraynamahastag: [],
            validasi: false,
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovation_event-Dokumentasi?f=',
            folder_dokumen: process.env.VUE_APP_URL_API + 'parastapainnovation_event-PDF?f=',
            project_id: process.env.VUE_APP_PROJECT_ID,
        }
    },
    methods: {
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        onhastagChangeSelect(events) {
            this.paramselectedhastag = [];
            for (let i = 0; i < events.length; i++) {
                try {
                    this.paramselectedhastag.push(parseInt(events[i].tag));
                } catch (error) {

                }
            }
            //alert(JSON.stringify(this.paramselectedhastag));
        },
        onhastagChangeDeselect(events) {
            //alert(JSON.stringify(events));
            var temp = [];
            temp.push(events);
            //alert(JSON.stringify(temp));
            var yghilang = '';
            for (let i = 0; i < temp.length; i++) {
                try {
                    yghilang = parseInt(temp[i].tag);
                } catch (error) {

                }
            }
            var temparray = [];
            for (let i = 0; i < this.paramselectedhastag.length; i++) {
                if (this.paramselectedhastag[i] !== JSON.stringify(yghilang)) {
                    try {
                        temparray.push(this.paramselectedhastag[i]);
                    } catch (error) {

                    }
                }
            }
            this.paramselectedhastag = temparray;
            //alert(JSON.stringify(this.paramselectedhastag));
        },
        async AmbilDataReff() {
            this.halamanloading = true;
            var mainAPIData = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIData.get("parastapainnovation-GetAllUser?random=" + random + "&project_id=" + this.project_id + "&levelinstansi=" + this.levelinstansi + "&role=" + this.roleuser).then(
                Response => {
                    this.datapesan = Response.data.response;
                    if (this.datapesan == 'success') {
                        this.datahastag = [];
                        this.hastag = [];
                        this.datahastag = Response.data.content.data;
                        this.datahastag.forEach((item) => {
                            this.hastag.push({
                                label: item.nama,
                                code: this.datahastag.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.hastag.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })
        },
        uploadfile(idnya, tipenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", idnya);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationfilenya-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepeta(idnya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", idnya);
            fd.append("filenya", document.getElementById(idnya).value);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationfilenya-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    document.getElementById(idnya).value == '';
                    this.pic = '';
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            return false;
        },
        onleveluserChange(a) {
            try {
                this.selectedleveluser = this.leveluser[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            window.location.replace("/Kalendar");
        },
        async AmbilDataSingel() {
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIDataSingel.get("parastapainnovation_event-GetByID?kode=" + this.secretencData + "&random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    //alert(this.secretencData);
                    this.agenda = Response.data.content.data[0].agenda;
                    this.agenda_eng = Response.data.content.data[0].agenda_eng;
                    this.topik = Response.data.content.data[0].topik;
                    this.topik_eng = (Response.data.content.data[0].topik_eng);
                    this.pengelola = (Response.data.content.data[0].pengelola);
                    this.lokasi = (Response.data.content.data[0].lokasi);
                    this.mulai = (Response.data.content.data[0].mulai);
                    this.selesai = (Response.data.content.data[0].selesai);
                    this.waktumulai = (Response.data.content.data[0].waktumulai);
                    this.waktuselesai = (Response.data.content.data[0].waktuselesai);
                    this.warna = (Response.data.content.data[0].warna);
                    this.lokasi = (Response.data.content.data[0].lokasi);
                    this.permasalahan = atob(Response.data.content.data[0].permasalahan);
                    this.permasalahan_eng = atob(Response.data.content.data[0].permasalahan_eng);
                    this.filenya_dokumen = Response.data.content.data[0].filenya_dokumen;
                    //document.getElementById('filenya_dokumen').value = Response.data.content.data[0].filenya_dokumen;
                    this.filenya_name = Response.data.content.data[0].filenya_name;
                    //document.getElementById('filenya_name').value = Response.data.content.data[0].filenya_name;
                    if (Response.data.content.data[0].hastag != '') {
                        var myArray = Response.data.content.data[0].hastag;
                        //alert(myArray.length);
                        this.arraynamahastag = [];
                        for (let i = 0; i < myArray.length; i++) {
                            //this.arraynamahastag.push(myArray[i].nama);
                            this.arraynamahastag.push({
                                label: myArray[i].nama,
                                code: myArray[i].code,
                                tag: myArray[i].id,
                            });
                            this.paramselectedhastag.push(myArray[i].id);
                        }
                    }

                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })
        },
        validasidata() {
            if (this.paramselectedhastag == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Pilih Penerima Event',
                });
                return false;
            }
            if (document.getElementById('agenda').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('agenda').focus();
                return false;
            }
            if (document.getElementById('agenda_eng').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('agenda_eng').focus();
                return false;
            }
            if (document.getElementById('pengelola').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('pengelola').focus();
                return false;
            }
            if (document.getElementById('topik').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('topik').focus();
                return false;
            }
            if (document.getElementById('topik_eng').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('topik_eng').focus();
                return false;
            }
            if (document.getElementById('lokasi').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('lokasi').focus();
                return false;
            }
            if (document.getElementById('mulai').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('mulai').focus();
                return false;
            }
            if (document.getElementById('selesai').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('selesai').focus();
                return false;
            }
            if (document.getElementById('waktumulai').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('waktumulai').focus();
                return false;
            }
            if (document.getElementById('waktuselesai').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('waktuselesai').focus();
                return false;
            }
            if (this.permasalahan == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Deskripsi',
                });
                return false;
            }
            if (this.permasalahan_eng == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Deskripsi (English)',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
        simpan() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            var fd = new FormData();
            fd.append("agenda", this.agenda);
            fd.append("agenda_eng", this.agenda_eng);
            fd.append("topik", this.topik);
            fd.append("topik_eng", this.topik_eng);
            fd.append("pengelola", this.pengelola);
            fd.append("lokasi", this.lokasi);
            fd.append("mulai", this.mulai);
            fd.append("selesai", this.selesai);
            fd.append("waktumulai", this.waktumulai);
            fd.append("waktuselesai", this.waktuselesai);
            fd.append("warna", this.warna);
            fd.append("permasalahan", this.permasalahan);
            fd.append("permasalahan_eng", this.permasalahan_eng);
            fd.append("hastag", this.paramselectedhastag);
            fd.append("filenya_dokumen", document.getElementById('filenya_dokumen').value);
            fd.append("filenya_name", document.getElementById('filenya_name').value);
            fd.append("project_id", this.project_id);
            fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_event-Add", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah tersimpan..', 'success').then(function () {
                            window.location.replace("/Kalendar");
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        update() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            //alert(this.secretencData);
            var fd = new FormData();
            fd.append("agenda", this.agenda);
            fd.append("agenda_eng", this.agenda_eng);
            fd.append("topik", this.topik);
            fd.append("topik_eng", this.topik_eng);
            fd.append("pengelola", this.pengelola);
            fd.append("lokasi", this.lokasi);
            fd.append("mulai", this.mulai);
            fd.append("selesai", this.selesai);
            fd.append("waktumulai", this.waktumulai);
            fd.append("waktuselesai", this.waktuselesai);
            fd.append("warna", this.warna);
            fd.append("permasalahan", this.permasalahan);
            fd.append("permasalahan_eng", this.permasalahan_eng);
            fd.append("hastag", this.paramselectedhastag);
            fd.append("filenya_dokumen", document.getElementById('filenya_dokumen').value);
            fd.append("filenya_name", document.getElementById('filenya_name').value);
            fd.append("id", this.secretencData);
            fd.append("project_id", this.project_id);
            fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_event-Update", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            window.location.replace("/Kalendar");
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.AmbilDataReff();
        if (this.secretencData != 'Tambah') {
            this.AmbilDataSingel();
        }
    }
}
</script>
<style></style>